
<script>
export default {
  el: '#basket-info',
  template: `
    <div class="basket-info">{{ quantity }} <span class="basket-price">(£{{ value | money }})</span></div>
        `,
  data() {
    return {
      name: ''
    }
  },
  computed: {
    quantity () {
      let total = 0;
      for (let i = 0; i < this.$store.state.basket.length; i++) {
        total += Number(this.$store.state.basket[i].quantity);
      }
      return total;
    },
    value () {
      if (this.$store.state.basketValues.gross) {
        return this.$store.state.basketValues.gross;
      }
      return 0.00;
    }

  },
  methods: {

  },
  mounted() {

    },

  watch: {
    quantity: function () {
      jQuery('.basket-info').addClass('changed');
    },

  },
};
</script>